/*
This file was generated by the Surface compiler.
*/

export const currencyInput = {
  mounted() {
    const input = this.el.querySelector("input")

    // Conditionally prevent user from typing non-digit characters
    switch (input.dataset.formattingRule) {
      case "deal_budget":
        break

      default:
        input.addEventListener("keypress", (e) => {
          if (e.which < 48 || e.which > 57) {
            e.preventDefault()
          }
        })
    }

    // Only get digit characters when pasting
    input.addEventListener("paste", (e) => {
      e.preventDefault()
      const pastedText = e.clipboardData.getData("text")
      const onlyDigits = pastedText.replace(/[^.\d]/g, "")
      const cursorPosStart = e.target.selectionStart
      const cursorPosEnd = e.target.selectionEnd
      const v = input.value
      const textBefore = v.substring(0, cursorPosStart)
      const textAfter = v.substring(cursorPosEnd, v.length)
      const mergedText = textBefore + onlyDigits + textAfter
      input.value = mergedText
    })
  },
}
